<template>
  <router-link
    :to="{ name: 'tender-summary', params: { tenderId: this.tender.id } }"
    tag="div"
    class="tender-card tender-card_small spacey-4"
  >
    <router-link
      :to="{ name: 'tender-summary', params: { tenderId: this.tender.id } }"
      class="text-bs break-word no-link"
    >
      {{ tender.name }}
    </router-link>
    <div class="tender-actions-row">
      <div class="flex-row spacex-12">
        <TenderCardOffersBadge :tender="tender" />
        <TenderCardCompaniesInfo :tender="tender" :is-active-switcher="false" />
      </div>
      <TenderCardActionsRow
        :tender="tender"
        class="spacex-4 inline-flex"
        @update-tenders="(e) => $emit('update-tenders', e)"
      />
    </div>
  </router-link>
</template>

<script>
  import TenderCardActionsRow from '@/components/tenders/tender-card/TenderCardActionsRow';
  import TenderCardOffersBadge from '@/components/tenders/tender-card/TenderCardOffersBadge';
  import TenderCardCompaniesInfo from '@/components/tenders/tender-card/TenderCardCompaniesInfo';

  export default {
    name: 'SmallTenderCard',
    components: { TenderCardCompaniesInfo, TenderCardOffersBadge, TenderCardActionsRow },
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
  };
</script>
